// src/modules/app-views/_apps/appmulti/coupons/pages/Document/decorators/response.js
// Backend already adds __operator + __remaining. FE passthrough so the form store
// receives the doc unchanged (expirationDate/startDate parse handled by SimpleDatePicker).
const decorateResponse = ctx => {
  const { doc } = ctx;
  if (!doc) return doc;
  return { ...doc };
};

export default decorateResponse;
